import { P2TextDescription } from 'react-bootstrap-common-script';
import { useGetSubmittedDocumentsQuery } from '../../../redux/services/getStageE';
import { useAppSelector } from '../../../redux/hook';
import { LottieLoader } from '../../../components/loader';
import { Separator } from '../../../components/separator';

/**
 * Legacy Documents to Bring - Same as commit a978266b (before Dec 16, 2025)
 * Fetches and displays documents from API
 */
function LegacyDocumentsToBringSegment() {
  const queryParameters = new URLSearchParams(window.location.search);
  const application_id = queryParameters.get('application_id');
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);

  const { data, isLoading } = useGetSubmittedDocumentsQuery(
    {
      application_id: application_id ?? '0',
      uinfin: loginUser?.uinfin ?? '',
      singpass_token: singpassToken ?? '',
    },
    { skip: application_id === '0' || application_id === null }
  );

  if (isLoading) {
    return <LottieLoader />;
  }

  if (data?.length === 0) {
    return null;
  }

  const uniqueByLabel = data?.filter(
    (e: any, index: number, self: any[]) =>
      e?.label &&
      index === self.findIndex(d => d?.label === e?.label)
  );
  
  return (
    <>
      <Separator variant="solid" style={{ margin: '48px 0 24px' }} />
      <div className="polymer-stage-e-documents_bring px-4 my-4">
        <P2TextDescription
          color="#333"
          title={'Documents to Bring'}
          description={'Please prepare the following documents in hard copy for our verification during the completion appointment.'}
        />
        <div className="polymer-stage-e-card pt-4">
          {uniqueByLabel.map((e: any, index: number) => {
            return (
              <p key={index}>
                {index + 1}. {e.label}
              </p>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default LegacyDocumentsToBringSegment;
